import { ReactElement, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { sharedMessages } from '@app/translations';
import { NotificationStatus } from '@app/constants';

export const getErrorNotificationProps = ({
  title,
  message,
}: {
  title: ReactNode;
  message: string;
}): {
  type: NotificationStatus;
  header: ReactElement;
  children: ReactElement;
} => ({
  type: NotificationStatus.error,
  header: <FormattedMessage {...sharedMessages.somethingWentWrong} />,
  children: (
    <span data-auto="error-message">
      {title}
      {message && ` ${message}`}
    </span>
  ),
});
